export const zeroPad = (number: number | undefined) => {
    if (number && number > 0) {
        return String(number).padStart(2, '0');
    }
    if (number === 0) {
        return '00';
    }
};
